import { AdPlaceholderFactory } from "@components/Advertisement/utils/helpers";
import { AdUnitNames } from "@components/Advertisement/utils/types";

type AdPlaceholderProps = {
  /** The classname of the component. */
  className?: string;
  /** The ad type to be displayed. */
  adType: AdUnitNames;
};

/** This is the placeholder to be displayed as placeholder for ads. */
const AdPlaceholder = ({
  className,
  adType,
}: AdPlaceholderProps): React.ReactElement => {
  const AdUnit = AdPlaceholderFactory(adType);

  if (typeof AdUnit === "undefined") return <></>;

  return (
    <div className={className} data-testid="ad-placeholder-component">
      <AdUnit adName={adType} />
    </div>
  );
};

export default AdPlaceholder;
